import { render, staticRenderFns } from "./weekProgram.vue?vue&type=template&id=35c28b40&scoped=true&"
import script from "./weekProgram.vue?vue&type=script&lang=js&"
export * from "./weekProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c28b40",
  null
  
)

export default component.exports